import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";
import { FrameMetricTooltip } from "./FrameMetricTooltip";

interface HFRProgressionChartProps {
  imagesForView: ImageMetadata[];
}

const HFRProgressionChart: React.FC<HFRProgressionChartProps> = ({
  imagesForView,
}) => {
  // Only use light frames for statistics
  const lightFrames = imagesForView.filter((img) => img.FrameType === "LIGHT");
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        minHeight: 400,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
      >
        HFR Progression
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Half Flux Radius measurements throughout the session
      </Typography>
      {lightFrames.length === 0 ? (
        <Typography color="text.secondary">No data available.</Typography>
      ) : (
        <Box sx={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
          <Box sx={{ minWidth: Math.max(lightFrames.length * 2, 800) }}>
            <ResponsiveContainer width="100%" height={280}>
              <LineChart
                data={lightFrames
                  .map((img, i) => ({ frame: i + 1, hfr: img.HFR }))
                  .filter((d) => typeof d.hfr === "number" && isFinite(d.hfr))}
              >
                <XAxis
                  dataKey="frame"
                  stroke="#a0a0a0"
                  tick={{ fill: "#a0a0a0" }}
                  tickLine={false}
                  axisLine={{ stroke: "#333" }}
                />
                <YAxis
                  stroke="#a0a0a0"
                  tick={{ fill: "#a0a0a0" }}
                  tickLine={false}
                  axisLine={{ stroke: "#333" }}
                  domain={[0, "auto"]}
                />
                <Tooltip content={<FrameMetricTooltip labelName="HFR" />} />
                <Line
                  type="monotone"
                  dataKey="hfr"
                  stroke="#4fc3f7"
                  strokeWidth={2}
                  dot={{ r: 2, fill: "#4fc3f7" }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HFRProgressionChart;
